import { useMutation, useQueryClient } from '@tanstack/react-query';

import API from '../../services/api';

import formulaKeys from './_queryKeys';

export default function useFormulaLabelsDeleteMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: API.deleteFormulaLabels,
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: formulaKeys.all,
            });
            queryClient.invalidateQueries({
                queryKey: ['personalization-map'],
            });
        },
    });
}
